module.exports = __webpack_public_path__ + "img/bubble.ba0eff8d.jpg";